// CompanyTheme.js
import { useMemo } from 'react';
import productThemes from './ProductThemes';
import { backgroundLight, textLight } from './defaultConfig';

const CompanyTheme = () => {
  let theme = localStorage.getItem('theme');

  if(!theme) {
    theme = {
      title: 'Default',
      primary: {
        main: '#2196f3',
      },
      secondary: {
        main: '#2196f3',
      },
    }
  }

  const selectedTheme = useMemo(() => {
    const themeTitle = theme;
    return themeTitle && themeTitle !== 'None'
      ? productThemes.find((themeColor) => themeColor.title === themeTitle)
      : null;
  }, [theme]);

  return useMemo(() => {
    return selectedTheme
      ? {
          mode: 'companyTheme',
          primary: {
            main: selectedTheme?.primary.main,
          },
          secondary: {
            main: selectedTheme?.secondary.main,
          },
          background: backgroundLight,
          text: textLight,
        }
      : null;
  }, [selectedTheme]);
};

export default CompanyTheme;
